// frontend/src/pages/OnboardingPage.js
import React from 'react';
import  { useEffect, useState } from 'react';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import OnboardingWizard from '../components/onboarding/OnboardingWizard';

import { useNavigate } from 'react-router-dom';


const OnboardingPage = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // LOG 1: Al montar el componente
  useEffect(() => {
    // console.log('🎯 [OnboardingPage] COMPONENTE MONTADO');
    // console.log('🎯 [OnboardingPage] isAuthenticated:', isAuthenticated);
    // console.log('🎯 [OnboardingPage] user:', user);
    // console.log('🎯 [OnboardingPage] localStorage token:', localStorage.getItem('token'));
    // console.log('🎯 [OnboardingPage] localStorage user:', localStorage.getItem('user'));
    // console.log('🎯 [OnboardingPage] onboardingCompleted:', localStorage.getItem('onboardingCompleted'));
  }, []);

  // LOG 2: Cada vez que cambian las dependencias
  useEffect(() => {
    // console.log('🔄 [OnboardingPage] useEffect ejecutado');
    // console.log('🔄 isAuthenticated:', isAuthenticated);
    // console.log('🔄 user:', user);

    // Si no está autenticado, redirigir al login
    if (!isAuthenticated) {
      // console.log('🚫 [OnboardingPage] No autenticado, redirigiendo a login');
      navigate('/login', { replace: true });
      return;
    }

    // Si está autenticado pero no hay user (cargando), esperar
    if (!user) {
      // console.log('⏳ [OnboardingPage] Esperando datos del usuario...');
      return;
    }

    // Si ya completó onboarding, ir a dashboard
    if (user.hasOnboarded) {
      navigate('/dashboard', { replace: true });
      return;
    }

    // console.log('✅ [OnboardingPage] Todo OK, mostrando wizard');
    setLoading(false);
  }, [isAuthenticated, user, navigate]);

  if (loading) {
    return (
      <Container className="d-flex flex-column justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Cargando onboarding...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-5" style={{ maxWidth: '600px' }}>
      <div className="text-center mb-5 text-light">
        <h1 className="fw-bold"> ¡Bienvenido a LinksEasy!</h1>
        <p className="text-light">Completa estos pasos para personalizar tu perfil</p>
      </div>
      
      <OnboardingWizard user={user} />
    </Container>
  );
};

export default OnboardingPage;